<style scoped lang="sass">
.dishes_list
  position: relative
  display: flex
  margin-bottom: 12px
  width: 235PX
  height: 84PX
  background: #fff
  border: 1px solid rgba(51, 68, 85, 0.09)
  border-radius: 4px
  overflow: hidden
  margin-right: 12PX

  &.dishes_list_active
    margin-bottom: 10px
    height: 58px

    .mask
      width: 64px

    .product
      width: 64px

    .infos

      .open_hours
        margin-top: 7px
        font-size: 12px
        font-weight: bold
        line-height: 12px
        color: rgba(51, 68, 85, 0.79)

        .hours
          margin-left: 5px
          font-weight: normal

  .mask
    position: absolute
    left: 0
    top: 0
    bottom: 0
    width: 100%
    background-color: #fff
    border-radius: 4px 0 0 4px
    z-index: 1
    opacity: .6

  .product
    position: relative
    height: 100%
    width: 86PX
    border-radius: 4px 0 0 4px
    flex-shrink: 0

    .quantity
      position: absolute
      top: 6px
      left: 6px
      height: 18px
      padding: 0 5px
      background-color: var(--menu-primary-background-colour)
      border: 1px solid #fff
      border-radius: 13px
      color: #fff
      font-size: 10px
      font-weight: bold
      line-height: 18px
      text-align: center

    .popular
      /* Layout Properties */
      position: absolute
      bottom: 4px
      left: 4px
      height: 16px
      padding: 0 4px
      background-color: var(--menu-primary-background-colour)
      border: 1px solid #fff
      border-radius: 10px
      color: #fff
      font-size: 9px
      font-weight: bold
      text-align: center
      line-height: 16px
      text-transform: uppercase
      opacity: 1

    .tags
      position: absolute
      top: 4px
      right: 4px
      display: flex
      flex-direction: column
      align-items: center

      .each_circle
        display: flex
        width: 18px
        height: 18px
        margin-bottom: 2px

        &:last-child
          margin-bottom: 0

        .each_circle_img
          width: 100%
          filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.4))

    .img
      width: 84PX
      height: 84PX
      object-fit: cover

  .infos
    flex: 1
    overflow: hidden
    display: flex
    flex-direction: column
    justify-content: space-between
    padding: 8px 0 7px 10px

    &.infos_border
      border: 1px solid rgba(51, 68, 85, 0.05)

    .name
      font-size: 12PX
      line-height: 14px
      padding-right: 20px
      color: var(--menu-primary-text-colour)
      flex-shrink: 0

    .info
      flex: 1
      width: 200px
      padding-top: 5px
      font-size: 10PX
      line-height: 12px
      color: var(--menu-primary-text-colour)

    .shop_box
      display: flex
      justify-content: space-between
      align-items: center
      padding-top: 3px

      .price
        font-size: 12PX
        line-height: 14px
        color: var(--menu-primary-text-colour)

      .unavailable
        height: 17px
        margin-right: 7px
        padding: 0 7px
        line-height: 17px
        background-color: #B00620
        color: #fff
        font-size: 10PX
        font-weight: bold
        border-radius: 13px
        z-index: 1
      .add_cart_button
        position: absolute
        right: 15PX
        .icon
          width: 20PX
          height: 20PX
          color: var(--menu-primary-background-colour) !important

    .masktext
      color: var(--menu-primary-text-colour)

.venue_group_disabled
  justify-content: flex-end !important

</style>

<template lang="pug">
  .dishes_list.ns(:class="{ dishes_list_active: type === 1 }")
    .product
      img.img(v-lazy="getProductsImg")
      span.quantity(v-if="quantity && !maskDisplay") X {{ quantity }}
      span.popular(v-if="enablePopular") {{ t('popular', 'Popular') }}
      .tags(v-if="tags && tags.length")
        span.each_circle(
          v-if="imgScr(item) !== 'other'"
          v-for="(item, index) in tags"
          :key="index"
        )
          img.each_circle_img(:src="imgScr(item)")
    .mask(v-if="maskDisplay")
    .infos(:class="{ infos_border: maskDisplay }")
      span.name.van-multi-ellipsis--l2.b(:class="{ masktext: maskDisplay }") {{ name }}
      .open_hours(v-if="type === 1")
        span.ls1 {{ t('open_hours', 'Open hours:') }}
        span.hours {{ openHours }}
      .info(v-if="description" :class="{ masktext: maskDisplay }")
        .content.van-multi-ellipsis--l2.o(v-if="descriptionIsHtml" v-html="description")
        .content.van-multi-ellipsis--l2.o(v-else) {{ description }}

      .shop_box(:class="{'venue_group_disabled': venueGroupDisabled}")
        span.price.ls1.b(v-if="!maskDisplay && priceAmount && !hidePrice" :class="{ masktext: maskDisplay }") {{ isMultiSize ? '' : (symbolPosition === 'after' ? '' : currencySymbol) }}{{ priceAmount }}{{ isMultiSize ? '' : (symbolPosition === 'after' ? ' ' + currencySymbol : '') }}
        span.unavailable.ls1(v-if="maskDisplay") {{ unavailableText }}
        span.add_cart_button
          icon.icon(@click="choose()" size="30") add_circle

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { _getDefaultProductsImg } from 'utils/defaultProductsImg'
import { convertPrice, formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { t } from '@/utils/language'

@Component({
  props: {
    imgUrl: String,
    name: String,
    description: String,
    descriptionIsHtml: Boolean, // Describe whether to use html   // '描述' 是否使用 html
    openHours: String,
    price: [Number, String],
    quantity: {
      type: Number,
      default: 0
    },
    unavailable: Boolean,
    unavailableText: { // Text in non selectable status   // 不可选状态的文案
      type: String,
      default: 'SOLD OUT'
    },
    type: Number,
    maskDisplay: {
      type: Boolean,
      default: false
    },
    venueGroupDisabled: {
      type: Boolean,
      default: false
    },
    enablePopular: {
      type: Boolean, default: false
    },
    sizeSettings: {
      type: Object
    },
    hidePrice: {
      type: Boolean, default: false
    },
    tags: Array // Product tag array   // 商品标签的数组
  },

  computed: {
    getProductsImg() {
      // Compatible with dirty data, when imgUrl has no value
      // 兼容脏数据，'imgUrl' 没有值的情况
      if (!this.imgUrl) return this.noPicImg
      // Judge whether the image url is the default image type
      // 判断图片 url 是否是默认图片类型
      const isDefaultProductsImg = this.imgUrl.includes('/img/product/')
      return isDefaultProductsImg ? _getDefaultProductsImg(this.imgUrl) : this.imgUrl
    },

    isMultiSize() {
      const settings = this.sizeSettings
      return settings?.mutipleSize && settings?.settings?.length > 1
    },

    priceAmount() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      const symbol = getCurrencySymbol()
      const position = getSymbolPosition()
      const enableMutipleSize = this.sizeSettings?.mutipleSize
      if (enableMutipleSize) {
        const ls = this.sizeSettings.settings.map(item => convertPrice(parseFloat(item.price)))
        const minPrice = formatDecimalNumber(Math.min(...ls))
        const maxPrice = formatDecimalNumber(Math.max(...ls))
        if (this.sizeSettings.settings.length === 1) {
          return `${minPrice}`
        } else {
          if (position === 'after') {
            return `${minPrice} ${symbol} - ${maxPrice} ${symbol}`
          }
          return `${symbol}${minPrice} - ${symbol}${maxPrice}`
        }
      } else {
        if (this._.isUndefined(this.price)) return
        return formatDecimalNumber(convertPrice(this.price))
      }
    },

    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },

    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  }
})

class RecommendItem extends Vue {
  noPicImg = require('@/assets/defaultProductsImg/Food.jpg')

  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  /**
   * @param item {String} Corresponding picture name
   * @returns {String} Corresponding picture address
   */
  /**
   * @param item {String} 对应的图片名称
   * @returns {String} 对应的图片地址
   */
  imgScr(item) {
    if (item === 'Gluten free') {
      return require('@/assets/spice/GlutenFree.png')
    } else if (item === 'Dairy free') {
      return require('@/assets/spice/DairyFree.png')
    } else if (item === 'Vegetarian') {
      return require('@/assets/spice/Vegetarian.png')
    } else if (item === 'Vegan') {
      return require('@/assets/spice/Vegan.png')
    } else {
      // The returned other is compatible with the tags types not found in the existing design drawings. The returned other is always hidden and not displayed 21/12/21
      // 返回 'other'，是为了兼容现有设计图中没有的 tags 类型，并且一律隐藏不显示
      return 'other'
    }
  }

  choose() {
    if (!this.maskDisplay) {
      this.$emit('add')
    }
  }
}

export default RecommendItem
</script>
